export const MERCHANT_AGREEMENTS = "/MerchantAgreement/GetMerchantAgreementForApproval"
export const MERCHANT_AGREEMENT_INSERT = "/MerchantAgreement/InsertMerchantAgreement"
export const MERCHANT_AGREEMENT_UPDATE = "/MerchantAgreement/UpdateMerchantAgreement"






